<template>
  <BaseModal :modal-name="name" max-width="max-w-2xl" @close="onClickCancel">
    <div class="mt-10">
      <div class="text-center text-primary">{{ text }}</div>
    </div>
    <div>
      <div
        class="mt-10 flex items-center justify-center space-x-8 text-sm md:justify-end"
      >
        <BaseButton
          theme="primary"
          size="normal"
          class="w-40"
          @click="onClickConfirm"
        >
          {{ $t('action.confirm') }}
        </BaseButton>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { useModalsStore } from '~~/stores/modals'

const name = 'simpleConfirmModal'
const modalsStore = useModalsStore()

const modalData = computed(() => {
  return modalsStore.getModalData(name)
})

const text = computed(() => {
  return modalData.value.text
})

const onClickCancel = () => {
  modalsStore.close(name)
}

const onClickConfirm = async () => {
  modalsStore.close(name)
}
</script>
